import { useState, useEffect } from 'react';
import { useChoreographer } from '@atlassian/jira-choreographer-services/src/main.tsx';

export function useCanShowExperiment({ skip }: { skip: boolean }) {
	const [canShowExperiment, setCanShowExperiment] = useState(false);
	const { startMessage, stopMessage } = useChoreographer('jira-loss-aversion-standard', {
		start: () => setCanShowExperiment(true),
		stop: () => setCanShowExperiment(false),
	});

	useEffect(() => {
		if (!skip) {
			startMessage();
		}

		return () => {
			stopMessage();
		};
	}, [startMessage, stopMessage, skip]);

	return { canShowExperiment };
}
